import { getClientSource } from "./Functions";

const isProduction = process.env.REACT_APP_ENV === "production";
const defaultDevBaseUrl = "https://tcs-6ep8.onrender.com";
const defaultProdBaseUrl =
    getClientSource() === "tcs"
        ? "https://tcs-6ep8.onrender.com"
        : "https://tcs-6ep8.onrender.com";

export const BASE_URL =
    process.env.REACT_APP_API_BASE_URL ||
    (isProduction ? defaultProdBaseUrl : defaultDevBaseUrl);
export const DEFAULT_PROFILE_IMAGE =
    "https://res.cloudinary.com/dmrs3v7fm/image/upload/v1742201213/TCS-Dashboard/profile/ypp3aruo8xfek8nnqg50.jpg";
